export default "__VITE_ASSET__ee4026fd__"